import { number, object, string } from 'yup'

export const brokersSchema = searchID => object({
	...!searchID && {
		officePickupID: number().required('Offices is required'),
		dates: string().required('Must provide a date'),
	},
	currency: string().required('Currency is required'),
	mainSite: string().nullable(),
	sites: string().required('Site is required'),
})